import { Theme, useMediaQuery, useTheme } from '@mui/material';

const useLowResolution = (): boolean => {
	const theme = useTheme<Theme>();
	return useMediaQuery(theme.breakpoints.down('sm'));
};

export default useLowResolution;
